/* global angular, Modernizr, $ */
angular.module('ua5App')
    .directive('siteFooter', ['$timeout', '$rootScope', function($timeout, $rootScope) {
        return {
            templateUrl: 'components/site_footer/site_footer.html',
            restrict: 'E',
            link: function($scope, $element, $attrs) {
                var hasStepped = false;
                var hideTimer;
                var time = 5000;
                var touch = Modernizr.touch;
                var mouseoverTimeout;
                var currentSpot;
                var $sprite = $element.find('.site-footer__top__button');

                // By default do not show landing page button
                $scope.onLandingPage = true;

                                //-- if not mobile
                if (!(Modernizr.touch && $(window).width() <= 767)) {
                    $element.hide();
                    $rootScope.$on('logoAnimationComplete', function() {
                        $element.delay(1600).fadeIn();
                    });
                }

                $sprite.on('mouseenter', function() {
                    if ($(this).hasClass('highlighted')) {
                        stepThroughIcon(true);
                        hasStepped = true;
                    }
                });

                $sprite.on('mouseleave', function() {
                    if ($(this).hasClass('highlighted') || hasStepped) {
                        stepThroughIcon(false);
                        hasStepped = false;
                    }
                });
                currentSpot = 0;

                function stepThroughIcon(goForward) {
                    var STEP_TIME = 30;
                    clearTimeout(mouseoverTimeout);

                    mouseoverTimeout = setTimeout(function() {
                        $sprite.removeClass('sprite-' + currentSpot);

                        if (goForward) {
                            currentSpot++;
                        } else {
                            currentSpot--;
                        }

                        $sprite.addClass('sprite-' + currentSpot);

                        if (currentSpot < 30 && goForward) {
                            stepThroughIcon(goForward);
                        } else if (currentSpot > 1 && !goForward) {
                            stepThroughIcon(goForward);
                        }

                    }, STEP_TIME);
                }

                function startHideTimer() {
                    hideTimer = $timeout(function() {
                        // After intial hide should hide more quickly
                        time = 250;
                        $scope.isHidden = true;
                        $scope.$apply();
                    }, time);
                }
                function stopHideTimer() {
                    $timeout.cancel(hideTimer);
                    $scope.isHidden = false;
                    $scope.$apply();
                }
                // Always show on touch devices
                if (!touch) {
                    startHideTimer();
                }
                // If not on landing page show the landing page button
                $scope.$watch(function() {
                    return $rootScope.onLandingPage;
                }, function(onLandingPage) {
                    $scope.onLandingPage = onLandingPage;
                });

                $scope.$on('nearFooter', function() {
                    stopHideTimer();
                });

                $scope.$on('farFromFooter', function() {
                    startHideTimer();
                });
            }
        };
    }])
;
